import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { PopupTriggerProps } from '@atlassian/jira-development-board-common/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './src/ui/commit-details-popup-view/__generated__/CommitDetailsPopupViewCommitDetailsPopupViewQuery$parameters';
import type { CommitDetailsPopupViewCommitDetailsPopupViewQuery } from './src/ui/commit-details-popup-view/__generated__/CommitDetailsPopupViewCommitDetailsPopupViewQuery.graphql';

export const commitDetailsEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			commitDetailsForIssue: CommitDetailsPopupViewCommitDetailsPopupViewQuery;
		},
		{},
		PopupTriggerProps,
		{}
	>,
	{
		issueId: string;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(() => {
		return import(
			/* webpackChunkName: "async-commit-details-popup-new" */ './src/ui/commit-details-popup-view/CommitDetailsPopupView.tsx'
		);
	}),
	getPreloadProps: ({ issueId }: { issueId: string }) => ({
		queries: {
			commitDetailsForIssue: {
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
